const au = {
  code: 'au',
  name: 'Australia',
  flag: '🇦🇺',
  localTips: [
    'Impersonation of the ATO, Services Australia, or your bank is common — hang up and call back using numbers from official websites.',
    'Parcel and toll-road SMS scams often use links to fake payment pages.',
  ],
  resources: [
    {
      title: 'Scamwatch',
      description: 'Report scams and read current warnings (ACCC).',
      url: 'https://www.scamwatch.gov.au/',
    },
    {
      title: 'ReportCyber',
      description: 'Report cybercrime including online fraud.',
      url: 'https://www.cyber.gov.au/report',
    },
    {
      title: 'ACMA — Do Not Call',
      description: 'Register and complain about unsolicited telemarketing calls.',
      url: 'https://www.donotcall.gov.au/',
    },
  ],
};

export default au;
